<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import CheckUnsaveChange from '@/components/shared/CheckUnsaveChange'
import AdminForm from '@/components/admin/AdminForm.vue'
import { AloDbUmbClasse } from '@/models/alodb/AloDbUmbClasse'
import AdminUmbClasseForm from '@/components/admin/umbClasse/AdminUmbClasseForm.vue'
import { SecurityItemsKeys } from '@/enum/SecurityItems'

@Component({
  name: 'AdminUmbClasse', 
  components:{
    AdminUmbClasseForm
  }
})
export default class AdminUmbClasse extends AdminForm<AloDbUmbClasse> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT_CLASS].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName(){
    return "UmbClasse"
  }

  get originalLibelle(){
    return this.original.UMC_LIBELLE
  }

}
</script>